// extracted by mini-css-extract-plugin
export default {"slide":"index_slide_SAT4q","big_pic":"index_big_pic_odGti","text":"index_text_QJNmS","title":"index_title_m-WKF","dot":"index_dot_sHXEM","current":"index_current_c9ygj"};